import apiData from "lib/stores/apiData";
import context from "lib/stores/context";

const setActiveCountry = id => {
  context.activeCountry = id;
  context.activeRegion = apiData.countries[id].region_id;
  context.activeView = "country";
  context.activeTabCountries = 0;
};

export default setActiveCountry;
